"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _style = _interopRequireDefault(require("./style.scss"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var STEP = 15;
var DurationField = function DurationField(props) {
  var disabled = props.disabled,
    input = props.input,
    className = props.className;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    mouseTimer = _useState2[0],
    setMouseTimer = _useState2[1];
  var clearTimeout = function clearTimeout() {
    if (mouseTimer) {
      window.clearTimeout(mouseTimer);
      setMouseTimer(null);
    }
  };
  var handleIncreaseDuration = function handleIncreaseDuration() {
    if (disabled) {
      return;
    }
    clearTimeout();
    setMouseTimer(window.setTimeout(handleIncreaseDuration, 150));
    var newValue = (input.value || 0) + STEP;
    if (!disabled && newValue <= 1439) {
      input.onChange(newValue);
    }
  };
  var handleDecreaseDuration = function handleDecreaseDuration() {
    if (disabled) {
      return;
    }
    clearTimeout();
    setMouseTimer(window.setTimeout(handleDecreaseDuration, 150));
    var newValue = (input.value || 0) - STEP;
    if (!disabled && newValue >= 15) {
      input.onChange(newValue);
    }
  };
  var classNameGroupAddon = "btn-duration".concat(disabled ? ' disabled' : '');
  var value = (0, _momentTimezone.default)().set('hour', 0).set('minute', 0).add(input.value, 'minutes');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _style.default['duration-field']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "duration-input-group ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
    disabled: true,
    type: "text",
    value: value.format('H:mm'),
    className: "input-duration".concat(disabled ? ' disabled' : '')
  }), /*#__PURE__*/_react.default.createElement("div", {
    onMouseDown: handleDecreaseDuration,
    className: classNameGroupAddon,
    onMouseLeave: clearTimeout,
    onMouseUp: clearTimeout,
    role: "presentation"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-minus",
    "aria-hidden": "true"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classNameGroupAddon,
    onMouseDown: handleIncreaseDuration,
    onMouseLeave: clearTimeout,
    onMouseUp: clearTimeout,
    role: "presentation"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-plus",
    "aria-hidden": "true"
  }))));
};

// Default Props
DurationField.defaultProps = {
  disabled: false,
  className: ''
};

// PropTypes
DurationField.propTypes = {
  input: _propTypes.default.shape({
    value: _propTypes.default.number,
    onChange: _propTypes.default.func,
    name: _propTypes.default.string
  }).isRequired,
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string
};
// Export default reduxForm
var _default = DurationField;
exports.default = _default;